<template>
<div class="chapter">
<div class="inner_page">
<div id="fm03">
<a id="pageiii">
<p class="title">C<span class="tsmall">HRISTOPHER</span><br/>B<span class="tsmall">ROOKMYRE</span></p>
<p class="title1">BRED</p>
<p class="title2">IN THE</p>
<p class="title3">BONE</p>
<p class="timage">
<img alt="" class="imgepub" id="img1" src="images/img_0001.jpg"/></p>
<p class="title4">Atlantic Monthly Press</p>
<p class="title5"><em class="italic">New York</em></p>
</a></div><a id="pageiii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?60fafe22